export const validateMobile = (mobile) => {
    const mobileRegex = /^^((?:\+27|27)|0)(\d{2})-?(\d{3})-?(\d{4})$$/;
    return mobileRegex.test(mobile);
};

export const dietaryOptions = [
    { value: 'No Pork', label: 'No Pork' },
    { value: 'No Beef', label: 'No Beef' },
    { value: 'No Fish', label: 'No Fish' },
    { value: 'Halaal', label: 'Halaal' },
    { value: 'Vegan', label: 'Vegan' },
    { value: 'Vegetarian', label: 'Vegetarian' },
    { value: 'Other', label: 'Other' },
];